module.exports = __webpack_public_path__ + "img/p2_left.032937d3.jpg";